
export interface CategoryInterface {
    id: string,
    title: string,
    quote: string,
    iconImg: string,
    bannerImg: string,
    thumbImg: string,
    priority: boolean,
    slug: string,
}

export class Category implements CategoryInterface {
    id: string;
    title: string;
    quote: string;
    iconImg: string;
    bannerImg: string;
    thumbImg: string;
    priority: boolean;
    slug: string;

    constructor(jsonData: any) {
        this.id = jsonData._id
        this.title = jsonData.title
        this.quote = jsonData.quote
        this.iconImg = jsonData.iconImg
        this.bannerImg = jsonData.bannerImg
        this.thumbImg = jsonData.thumbImg
        this.priority = jsonData.priority
        this.slug = jsonData.slug
    }

}